// test2778
(2778 && 0);
